import React from 'react';
import { AppProvider as PolarisAppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import createApp from '@shopify/app-bridge';

// Override font in Polaris theme
const polarisTheme = {
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  }
};

export default function ShopifyProvider({ children }) {
  const params = new URLSearchParams(window.location.search);
  const shop = params.get('shop');
  const host = params.get('host');
  const config = {
    apiKey: 'e01adf90e60dcfdb4e39b5485859d18b', // Hardcoded for now
    shopOrigin: shop,
    host,
    forceRedirect: true,
  };

  // Debug logs for origin and context
  console.log('[ShopifyProvider] shop:', shop, 'host:', host, 'apiKey:', config.apiKey);
  console.log('[ShopifyProvider] window.location.origin:', window.location.origin);
  console.log('[ShopifyProvider] document.referrer:', document.referrer);
  // Removed window.top.location debug log to prevent cross-origin SecurityError

  // Create App Bridge instance for session token usage
  const appBridgeApp = React.useMemo(() => createApp(config), [host, shop]);

  // Debug statement to check if API key is injected at build time
  console.log('DEBUG: REACT_APP_SHOPIFY_API_KEY =', process.env.REACT_APP_SHOPIFY_API_KEY);

  return (
    <PolarisAppProvider i18n={{}} theme={polarisTheme}>
      <AppBridgeProvider config={config} app={appBridgeApp}>
        {children}
      </AppBridgeProvider>
    </PolarisAppProvider>
  );
}
